module.exports = __webpack_public_path__ + "img/19.e941f633.jpg";